<template>
  <div class="cont-box">
    <el-table :data="datas" style="width: 100%;" max-height="580" border>
      <el-table-column prop="month" label="月份">
      </el-table-column>
      <el-table-column prop="province" label="省份">
      </el-table-column>
      <el-table-column prop="htMb" label="合同目标">
      </el-table-column>
      <el-table-column prop="htSj" label="合同实际">
      </el-table-column>
      <el-table-column prop="htWcl" label="合同完成比" width="100">
      </el-table-column>
      <el-table-column prop="htLj" label="合同当年累计" width="110">
      </el-table-column>
      <el-table-column prop="htTq" label="合同上年同期" width="110">
      </el-table-column>
      <el-table-column prop="hkMb" label="回款目标">
      </el-table-column>
      <el-table-column prop="hkSj" label="回款实际">
      </el-table-column>
      <el-table-column prop="hkWcl" label="回款完成比" width="100">
      </el-table-column>
      <el-table-column prop="hkLj" label="回款当年累计" width="110">
      </el-table-column>
      <el-table-column prop="hkTq" label="回款上年同期" width="110">
      </el-table-column>
      <el-table-column prop="fyMb" label="费用目标">
      </el-table-column>
      <el-table-column prop="fySj" label="费用实际">
      </el-table-column>
      <el-table-column prop="fyWcl" label="费用完成比" width="100">
      </el-table-column>
      <el-table-column prop="fyLj" label="费用当年累计" width="110">
      </el-table-column>
      <el-table-column prop="fyTq" label="费用上年同期" width="110">
      </el-table-column>
      <el-table-column prop="zbMb" label="中标目标">
      </el-table-column>
      <el-table-column prop="zbSj" label="中标实际">
      </el-table-column>
      <el-table-column prop="zbWcl" label="中标完成比" width="100">
      </el-table-column>
      <el-table-column prop="zbLj" label="中标当年累计" width="110">
      </el-table-column>
      <el-table-column prop="zbTq" label="中标上年同期" width="110">
      </el-table-column>
      <el-table-column prop="srMb" label="收入目标">
      </el-table-column>
      <el-table-column prop="srSj" label="收入实际">
      </el-table-column>
      <el-table-column prop="srWcl" label="收入完成比" width="100">
      </el-table-column>
      <el-table-column prop="srLj" label="收入当年累计" width="110">
      </el-table-column>
      <el-table-column prop="srTq" label="收入上年同期" width="110">
      </el-table-column>
      <el-table-column prop="ysLj" label="应收账款累计" width="110">
      </el-table-column>
      <el-table-column prop="jzRq" label="截止日期" width="110">
      </el-table-column>
      <el-table-column prop="dqBs" label="大区标识">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    name: 'SellConfirm',
    props: ['datas'],
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
</style>
